// migrationAuthEpoch.js
//
// Client-side session epoch for dropspot.live → orbital.live migration.
// Firestore rules use the same cutover via request.auth.token.auth_time
// (see MIGRATION_AUTH_TIME_CUTOVER_UNIX in firestore.rules).

export const AUTH_SESSION_EPOCH = '2026-06-06-orbital-migration';
export const AUTH_SESSION_EPOCH_STORAGE_KEY = 'authSessionEpoch';
